import { Directive, forwardRef, NgModule } from "@angular/core";
import { CheckboxRequiredValidator, NG_VALIDATORS } from "@angular/forms";

import { InputsModule } from "./inputs";

/**
 * Validator for Vattenfall checkbox's required attribute in template-driven checkbox.
 * Current `CheckboxRequiredValidator` only work with `input type=checkbox` and does not
 * work with `ui-input`.
 */
@Directive({
  selector: `
    ui-input[type=checkbox][required][formControlName], ui-input[type=checkbox][required][formControl], ui-input[type=checkbox][required][ngModel],
    ui-input[type=option][required][formControlName], ui-input[type=option][required][formControl], ui-input[type=option][required][ngModel],
    ui-input[type=switch][required][formControlName], ui-input[type=switch][required][formControl], ui-input[type=switch][required][ngModel],
  `,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => OptionsCheckboxRequiredValidator),
      multi: true,
    },
  ],
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class OptionsCheckboxRequiredValidator extends CheckboxRequiredValidator {}

/**
 * The `OptionsModule` contains utilities for input components that selects single options.
 */
@NgModule({
  declarations: [OptionsCheckboxRequiredValidator],
  imports: [InputsModule],
  exports: [OptionsCheckboxRequiredValidator],
})
export class OptionsModule {}
